/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Vehicle_Maintenance_DescriptionInputs */

const en_case_section_vehicle_maintenance_description = /** @type {(inputs: Case_Section_Vehicle_Maintenance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The vehicle whose maintenance is in dispute.`)
};

const pt_br2_case_section_vehicle_maintenance_description = /** @type {(inputs: Case_Section_Vehicle_Maintenance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O veículo cuja manutenção está em disputa.`)
};

/**
* | output |
* | --- |
* | "The vehicle whose maintenance is in dispute." |
*
* @param {Case_Section_Vehicle_Maintenance_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_vehicle_maintenance_description = /** @type {((inputs?: Case_Section_Vehicle_Maintenance_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Vehicle_Maintenance_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_vehicle_maintenance_description(inputs)
	return pt_br2_case_section_vehicle_maintenance_description(inputs)
});